var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "as-work-order-wrap" },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: { "max-height": "600", data: _vm.tableData },
          on: { "filter-change": _vm.filterChange }
        },
        [
          _vm.type === "asOrder"
            ? _c("el-table-column", {
                attrs: {
                  prop: "exceptionOrderNo",
                  label: "工单号",
                  width: "180"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "order"
            ? _c("el-table-column", {
                attrs: { prop: "businessKey", label: "子订单号", width: "180" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.type === "order"
            ? _c("el-table-column", {
                attrs: {
                  prop: "exceptionOrderNo",
                  label: "关联工单",
                  width: "180"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "workOrderTypeDesc", label: "工单类型" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "statusDesc",
              label: "工单状态",
              "column-key": "statusDesc",
              filterable: "",
              filters: [
                { text: "新建", value: 1 },
                { text: "开始处理", value: 2 },
                { text: "已处理", value: 3 },
                { text: "驳回处理", value: 4 },
                { text: "完成", value: 99 },
                { text: "关闭", value: 0 }
              ]
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "createdByName", label: "创建人" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "operatorName", label: "受理人" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.targetSystem == 1
                      ? _c("span", [_vm._v("客服")])
                      : scope.row.targetSystem == 5
                      ? _c("span", [_vm._v(_vm._s(_vm.userName))])
                      : _c("span", [_vm._v("--")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "createdAt", label: "创建时间" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "rejectOrder",
                        attrs: { type: "text" },
                        on: {
                          click: function($event) {
                            return _vm.getDetail(scope.row)
                          }
                        }
                      },
                      [_vm._v("查看详情")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.totalElements
        ? _c("el-pagination", {
            attrs: {
              "page-size": _vm.size,
              "current-page": _vm.page,
              "page-sizes": [10, 20, 50, 100],
              "pager-count": 11,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.totalElements
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96289fe4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96289fe4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aftersale/work-order.vue
// module id = null
// module chunks = 